export const IndeterminateLoader = ({ loading }: { loading: boolean }) => {
  return loading ? (
    <div className="progress-bar">
      <div className="progress-bar-value"></div>
    </div>
  ) : null;
};
